// extracted by mini-css-extract-plugin
module.exports = {"closeButtonWrapper":"DialogCloseButton_closeButtonWrapper__z3TW2"};